import * as yup from 'yup';

const LoginValidations = yup.object().shape({
    email: yup.string().trim().required('Enter your email.').email('Enter a valid email address.'),
    password: yup.string().required('Enter your password.')
});

export default LoginValidations;
